import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  transform(string: string, n?: number): string {
    return string?.length > n ?  string?.substring(0, n) + "...":string
  }
}
